<div id="enduser" class="subBlockContainer">
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div>
      <div *ngIf="loadContent && showTenants">
        <div id="tenantTabs" class="tenant-tab-background">
          <ul id="pills-tab" class="nav nav-pills mb-3 tenant-ul" role="tablist">
            <li class='nav-item' *ngFor="let protype of subscriptionProgramTypes; let idx = index">
              <a *ngIf="protype == 'CSP'" id="pills-{{protype}}-tab" [attr.aria-controls]="'pills-'+protype"
                data-toggle="pill" data-placement="bottom" href="#maintabs-{{protype}}"
                [attr.aria-selected]="idx == 0?'true':'false'" class="nav-link" [class.active]="idx == 0" role="tab"
                title="MICROSOFT CSP">{{protype}}</a>
              <a *ngIf="protype == 'ADM'" id="pills-{{protype}}-tab" [attr.aria-controls]="'pills-'+protype"
                data-toggle="pill" data-placement="bottom" href="#maintabs-{{protype}}"
                [attr.aria-selected]="idx == 0?'true':'false'" class="nav-link" [class.active]="idx == 0" role="tab"
                title="AUTODESK MONTHLY">{{protype}}</a>
              <a *ngIf="protype == 'ADY'" id="pills-{{protype}}-tab" [attr.aria-controls]="'pills-'+protype"
                data-toggle="pill" data-placement="bottom" href="#maintabs-{{protype}}"
                [attr.aria-selected]="idx == 0?'true':'false'" class="nav-link" [class.active]="idx == 0" role="tab"
                title="AUTODESK YEARLY">{{protype}}</a>
              <a *ngIf="protype == 'INTA'" id="pills-{{protype}}-tab" [attr.aria-controls]="'pills-'+protype"
                data-toggle="pill" data-placement="bottom" href="#maintabs-{{protype}}"
                [attr.aria-selected]="idx == 0?'true':'false'" class="nav-link" [class.active]="idx == 0" role="tab"
                title="INTERACTIVE">{{protype}}</a>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade" *ngFor="let proType of subscriptionProgramTypes; let idx = index"
              [class.active]="idx == 0" [class.show]="idx == 0" id="maintabs-{{proType}}" role="tabpanel"
              [attr.aria-labelledby]="'pills-' + proType">
              <app-csp-tenant
                [cartId]="cartId" [proType]="proType"
                (selectCSPTenantEvent)="receiveCSPSelectTenant($event)"
                (selectADMTenantEvent)="receiveADMSelectTenant($event)"
                (selectADYTenantEvent)="receiveADYSelectTenant($event)"
                (selectINTATenantEvent)="receiveINTASelectTenant($event)"
                (selectMpnIdEvent)="receiveSelectMpnId($event)"
                (getCSPTenantViewEvent)="receiveCSPTenant($event)">
              </app-csp-tenant>
            </div>
          </div>
        </div>
        <div class="button-center" [class.hidebtn]="!loadContent">
          <button class="button button-red button-large" id="tenant_next" [disabled]="(!selectCSPTenantEvent || selectCSPTenantEvent.out_status === 'SA') && !selectINTATenantEvent && !selectADMTenantEvent && !selectADYTenantEvent" (click)="nextPage()">Next</button>
        </div>
      </div>
      <div *ngIf="loadContent && !showTenants">
        <div class="noData-wrapper">

          <label class="noData-label">
            Would you like to use Autopilot feature? <br />
          </label>

          <br />
          <div class="button-center">
            <button class="button button-red button-large" (click)="showTenants = true;">Yes</button>
          </div>
          <div class="button-center">
            <button class="button button-red button-large" (click)="skipToNextStep()">No</button>
          </div>
        </div>
      </div>

      <div id="bottom-navigation" [class.hidebtn]="!loadContent">
        <button *ngIf="checkoutViewModel?.firstStep != 'TENANT'" (click)="goPrevious()">Previous</button>
        <span *ngIf="checkoutViewModel?.firstStep != 'TENANT'">&nbsp;|&nbsp;</span>
        <!-- <ng-container *ngIf="serial;else goRenewals">
          <button class="btnLink" (click)="backtoRenewals()">Back to renewals</button>
        </ng-container>
        <ng-template #goRenewals>
          <button class="btnLink" (click)="backtoCart()">Back to cart</button>
        </ng-template> -->


        <ng-container [ngSwitch]="backto">
          <button *ngSwitchCase="'renewal'" (click)="backtoRenewals()">Back to renewals
          </button>
          <button *ngSwitchCase="'quote'"  (click)="backtoQuotes()">Back to quotes
          </button>
          <button *ngSwitchDefault  (click)="backtoCart()">Back to cart</button>
        </ng-container>

        <!-- <button class="btnLink"  (click)="backtoCart()">Back to cart</button> -->
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" [scrollAfterLoading]="true"  [isScrolled]="false" [showBlurTable]="true"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>
